import React from "react";
import { useStore } from "zustand";
import { accountStore, KYC_Status } from "../entities/account";
import { EntityType } from "../static/types";
import {
  sessionStore,
  useCurrentUser,
} from "entities/session/model/sessionModel";
import useSubAccount from "./useSubAccount";

const useCanAction = () => {
  const user = useCurrentUser();
  const { entity } = useStore(sessionStore);
  const {
    setInactiveAccountModal,
    setSignContractModal,
    setInactivePinCodeModal,
    setInactiveEmailModal,
    setNotVerifiedModal,
    setCrsDataModal,
    setCantTradeModal,
    logout,
    crsData,
  } = useStore(sessionStore);
  const { kyc, kyb } = useStore(accountStore);
  const { subAccount, canTrade } = useSubAccount();

  const action = (cb: any, type?: "fx" | string) => {
    if (!user) {
      // logout
    } else if (subAccount && !canTrade) {
      setCantTradeModal(true);
    } else if (
      entity === EntityType.Individual
        ? !kyc || [KYC_Status.None, KYC_Status.Rejected].includes(kyc?.status)
        : !kyb || [KYC_Status.None, KYC_Status.Rejected].includes(kyb?.status)
    ) {
      setNotVerifiedModal(true);
    } else if (
      entity === EntityType.Individual
        ? kyc?.status === KYC_Status.Pending
        : kyb?.status === KYC_Status.Pending
    ) {
      setInactiveAccountModal(true);
    } else if (!user?.isEmailVerified) {
      setInactiveEmailModal(true);
    } else if (!user?.hasPinCode) {
      setInactivePinCodeModal(true);
    } else if (!crsData || crsData.length === 0) {
      setCrsDataModal(true);
    } else if (!user?.signContract) {
      setSignContractModal(true);
    } else {
      if ([4662, 4663, 4664, 4665, 4832, 4996, 6780].includes(user.id)) {
        if (type === "fx") {
          cb();
        } else {
          // TODO: show modal
        }
      } else {
        cb();
      }
    }
  };

  return action;
};

export default useCanAction;
